import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/Checkout/Checkout.js
const Checkout = () => (
  <NoSettings text="Checkout steps (contact, shipping, billing, payment) with the cart total. No settings." />
);

export default Checkout;
